// AUTO-GENERATED GraphQL Builder for CurlecRefundResult
import * as Builders from '../';
export class CurlecRefundResultBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  amount(){ return this.add('amount'); }
  refundRefs(){ return this.add('refundRefs'); }
  simulated(){ return this.add('simulated'); }
  ledgerSettled(){ return this.add('ledgerSettled'); }
}
